<template>
    <BaseDataTable 
        v-if="itemsLoaded"
        :headers="headers"
        :items="items"
        hide-default-footer
        class="office-form-table"
        dense
        height="400"
        style="overflow-y:auto"
    >
        <!-- INCLUI TEMPLATES DOS HEADERS -->
        <template v-for="(h, i) in headers" v-slot:[`header.${h.value}`]>
            <div :key="i" style="background-color:#F0F0F7">
                <v-switch
                    v-model="headerCheckAll[i]"
                    class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
                    inset
                    dense
                    hide-details
                    color="secondary"
                    @click="checkAll(i)"
                />
                <p class="pl-1 mb-0 d-inline-block" style="font-weight:700">
                    <b>{{ h.text }}</b>
                </p>
            </div>
        </template>
        <!-- INCLUI TEMPLATES DOS ITEMS -->
        <template v-for="(modality, i) in modalityTypes" v-slot:[`item.${modality}.text`]="{ item }">
            <v-tooltip 
                bottom 
                max-width="400px"
                open-delay="1000"
                :key="item[modality].text" 
                v-if="item[modality].text" 
                :disabled="item[modality].tooltip == null || item[modality].tooltip.length == 0">
                <template v-slot:activator="{ on }">
                    <div v-on="on" style="max-width:400px; overflow:hidden; padding-left:5px;">
                        <v-switch
                            v-model="item[modality].value"
                            class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
                            inset
                            dense
                            hide-details
                            color="secondary"
                            @click="checkOne(i)"
                        />
                        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
                            {{ item[modality].text }}
                        </p>
                    </div>
                </template>
                <span>
                    <p>{{ item[modality].text }}</p>
                    <p>{{ item[modality].tooltip }}</p>
                </span>
            </v-tooltip>
          </template>
    </BaseDataTable>
</template>
<script>
import { LoadingRequest } from "@/mixins/LoadingMixin";
import API from "@/modules/modality/api";
export default {
    mixins: [ 
        LoadingRequest 
    ],
    data() {
        return {
            // Tipos de modalidade
            modalityTypes: { type: Array },
            // Cabeçalhos da tabela
            headers: { type: Array },
            // Items da tabela
            items:  { type: Array },
            // Booleanos indicando se as modalidades tem todos os items selecionados
            headerCheckAll: { type: Array },
            // Indica que os items já foram carregados
            itemsLoaded: false
        };
    },
    props: {
        // Id do grupo economico dessa lista de permissões.
        economicGroupId: { type: String, required: true },
        // Id do usuário/escritório dessa lista de permissões.
        targetId: { type: String, required: true },
        // Determina qual endpoint será usado para se comunicar com o servidor.
        targetAPI: { type: String, required: true },
    },
    mounted() {
        this.getModalities().then(()=>
        this.getSubModalities().then(()=>
        this.getCurrentPermissions().then(()=>
        { this.itemsLoaded = true; })));
    },
    methods: {
        // Envia as configurações atuais para o banco de dados.
        async save() {
            this.withLoading(
                this.postData().then(() =>
                    this.showAlertNotification({ message:"Permissões alteradas com sucesso!", type:"success" })
                ).catch((error)=>
                    this.showAlertNotification({
                    message: !error.response
                        ? "Um erro ocorreu ao tentar salvar as permissões."
                        : error.response.data.details &&
                        error.response.data.details.length > 0
                        ? error.response.data.details.reduce(
                            (acc, { message }) => acc.concat(message),
                            ""
                        )
                        : error.response.data.error_description,
                    type: "error"
                    })
                )
            )
        },
        async postData() {
            let permissions = [];

            for(let i = 0; i < this.modalityTypes.length; i++) {
                for(let j = 0; j < this.items.length; j++) {
                    if(this.items[j][this.modalityTypes[i]].value) {
                        permissions.push(this.items[j][this.modalityTypes[i]].id);
                    }
                }
            }

            await API.postPermissions(this.targetAPI,this.targetId, this.economicGroupId, permissions);
        },
        // Obtém os tipos de modalidades e gera os cabeçalhos da tabela
        async getModalities() {
            // const { data } = await API.getModality();
            const { data } = await API.getPermissionModalities(this.targetAPI,this.targetId, this.economicGroupId);
            this.modalityTypes = [];
            this.headers = [];

            for(let i = 0; i < data.length; i++) {
                this.modalityTypes.push(data[i].id);
                this.headers.push({ text: data[i].nome, value: `${data[i].id}.text`, sortable:false });
            }
        },
        // Obtém as subs de todas as modalidades e gera os items da tabela
        async getSubModalities() {
            if(this.modalityTypes.length > 0) {
                this.items = [];
                const baseItem = {};

                // cria um objeto base para cada item de cada modalidade.
                for(let i = 0; i < this.modalityTypes.length; i++) {
                    baseItem[this.modalityTypes[i]] = { text:null };
                }

                for(let i = this.modalityTypes.length - 1; i >= 0; i--) {
                    const { data } = await API.getPermissionSubModalities(this.targetAPI,this.targetId, this.economicGroupId, this.modalityTypes[i]);
                    
                    // a modalidade não tem nenhuma sub cadastrada.
                    if(data.length == 0) {
                        delete baseItem[this.modalityTypes[i]];
                        this.modalityTypes.splice(i, 1);
                        this.headers.splice(i, 1);
                        continue;
                    }

                    // cria os items para a modalidade da iteração atual.
                    for(let j = 0; j < data.length; j++) {
                        // cria o item se necessário, já com o valor padrão para cada modalidade.
                        if(this.items[j] == null) {
                            this.items[j] = {...baseItem};
                        }

                        this.items[j][this.modalityTypes[i]] = { value:false, text:data[j].nome, id:data[j].id, tooltip:data[j].tooltip };
                    }
                }
            }
        },
        // Obtém as permissões atuais do banco de dados e atualiza os itens de acordo.
        async getCurrentPermissions() {
            const { data } = await API.getPermissions(this.targetAPI, this.targetId, this.economicGroupId);
            
            for(let i = 0; i < this.modalityTypes.length; i++) {
                for(let j = 0; j < this.items.length; j++) {
                    if(data.includes(this.items[j][this.modalityTypes[i]].id)) {
                        this.items[j][this.modalityTypes[i]].value = true;
                    }
                }
            }
        },
        // executa quando há seleção em um item da modalidade de indice "index"
        // e muda o valor do switch do header de acordo com os valores dos items
        checkOne(index){
            let allChecked = true;

            for(let i = 0; i < this.items.length; i++) {
                if(!this.items[i][this.modalityTypes[index]].value) {
                    allChecked = false;
                    break;
                }
            }

            this.headerCheckAll[index] = allChecked;
        },
        // executa quando há alteração no switch de um header
        // seleciona todas as subs da modalidade de indice "index"
        checkAll(index){
            let value = this.headerCheckAll[index];

            for(let i = 0; i < this.items.length; i++) {
                this.items[i][this.modalityTypes[index]].value = value;
            }
        }
    }
}
</script>
<style scoped>
    td.text-start {
        white-space: nowrap;
    }
</style>
